<template>
  <div>
    <surveys-table
      surveyName="IDQOL"
      surveyCode="IDQOL"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_IDQOL,
        viewDetail: permissions.SEE_DETAIL_SURVEY_IDQOL,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
